// store 存储token、用户信息
export default {
  token: null,
  openId: null,
  userInfo: null,
  updateInfo: false   // 重新获取用户数据
}



// WEBPACK FOOTER //
// ./src/store/index.js